module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationpage",
    attrs: {
      "id": "d7e142"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }), _c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "d7e143"
    }
  }, [_c('i', [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_c('i', [_vm._v("For Mom (1947–2009) Thank you Mom for your unconditional love, acceptance, and willingness to talk openly and honestly, even about the hard topics.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_c('i', [_vm._v("To Jennifer, my best friend, my lover, my partner in crime. Thank you for helping me find the light.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_c('i', [_vm._v("P.S. I love you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2655e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_9781440506963_epub_ded.vue
// module id = 72
// module chunks = 0